import api from "./api";

export type RevenueTxType = "all" | "athlete_plans" | "lives" | "club_invoices" | "affiliate";

export type RevenueMonth = {
  ym: string;
  athlete_plans: number;
  lives: number;
  club_invoices: number;
  affiliate_cost: number;
  affiliate_revenue: number;
};

export type RevenueSummary = {
  from: string;
  to: string;
  rate: number; // EUR → RON
  totals: {
    athlete_plans_ron: number;
    lives_ron: number;
    club_invoices_ron: number;
    affiliate_cost_ron: number;
    affiliate_revenue_ron: number;
    gross_ron: number;
    net_ron: number;
  };
  counts: {
    athlete_plans: number;
    lives: number;
    club_invoices: number;
    affiliate_cost: number;
    affiliate_revenue: number;
  };
  months: RevenueMonth[];
};

export type RevenueTx = {
  type: "athlete_plans" | "lives" | "club_invoices" | "affiliate";
  id: string;
  date: string;
  label: string;
  payer?: string | null;
  amount_cents: number;
  currency: string;
  amount_ron_cents?: number | null;
  billing_reason?: string | null;
  is_cost?: boolean;
};

export async function getRevenueSummary(from?: string, to?: string): Promise<RevenueSummary> {
  const { data } = await api.get<RevenueSummary>("/revenue/summary", { params: { from, to } });
  return data;
}

export async function getRevenueTransactions(
  from?: string,
  to?: string,
  type: RevenueTxType = "all"
): Promise<RevenueTx[]> {
  const { data } = await api.get<RevenueTx[]>("/revenue/transactions", { params: { from, to, type } });
  return data;
}
